import { z } from "zod";
import { timestampSchema } from "../utility/index.js";
const activeDeploymentSchema = z.object({
  /** uid of the publish record for the last successful deployment */
  uid: z.string(),
  /** subdomain or custom domain */
  domain: z.string(),
  /** timestamp of the last successful deployment */
  publishedAt: timestampSchema
});
export {
  activeDeploymentSchema
};
//# sourceMappingURL=active-deployment.js.map
